/* eslint-disable sonarjs/no-identical-functions */
import { UseI18nHook } from "@core/i18n/i18n";
import { UseNavigationHook } from "@core/routing/use-navigate";
import { getEnumValues } from "@utils/enum-utils";
import { Dayjs } from "dayjs";


export enum NotificationType {
	PATIENT_PROGRAM_STARTED = "PATIENT_PROGRAM_STARTED",
	PATIENT_PROGRAM_ENDING_SOON = "PATIENT_PROGRAM_ENDING_SOON",
	PATIENT_PROGRAM_ENDED = "PATIENT_PROGRAM_ENDED",
	PATIENT_HAS_DELETED_HIS_ACCOUNT = "PATIENT_HAS_DELETED_HIS_ACCOUNT",
	PATIENT_REGISTERED = "PATIENT_REGISTERED",
	HCT_INVITATION_SENT = "HCT_INVITATION_SENT",
	HCT_INVITATION_ACCEPTED = "HCT_INVITATION_ACCEPTED",
	PT_ACCOUNT_VALIDATION_PENDING = "PT_ACCOUNT_VALIDATION_PENDING",
	PT_ACCOUNT_VALIDATED = "PT_ACCOUNT_VALIDATED",
	PT_LEFT_HCT = "PT_LEFT_HCT",
}

export const notificationTypes = getEnumValues(NotificationType);

export type NotificationObject = {
	id: NotificationId;
	type: NotificationType;
	data: unknown;
	creationDate: Dayjs;
	isRead: boolean;
};

export type NotificationId = string;

export interface NewUnsentNotificationData {
	notification?: Notification;
	count: number;
}

export type LoadNotificationOutput = {
	notifications: Notification[];
	reachedEnd: boolean;
	unreadNotificationsCount: number;
};

export abstract class Notification {
	constructor(protected readonly notification: NotificationObject) {}

	abstract format(i18n: UseI18nHook): string;

	abstract onClick(navigate: UseNavigationHook): void;

	public markAsRead(): void {
		this.notification.isRead = true;
	}

	public markAsUnread(): void {
		this.notification.isRead = false;
	}

	get isRead(): boolean {
		return this.notification.isRead;
	}

	get id(): NotificationId {
		return this.notification.id;
	}

	get type(): NotificationType {
		return this.notification.type;
	}

	get creationDate(): Dayjs {
		return this.notification.creationDate;
	}
}

export interface PatientNotificationData {
	id: string;
	firstName: string;
	lastName: string;
}

export interface PtNotificationData {
	id?: string;
	firstName: string;
	lastName: string;
}
